import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import { BaseTransformer } from './BaseTransformer';
export var CrmAccountTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(CrmAccountTransformer, _BaseTransformer);
  var _super = _createSuper(CrmAccountTransformer);
  function CrmAccountTransformer() {
    _classCallCheck(this, CrmAccountTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(CrmAccountTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        accountStatus: data.account_status,
        accountName: data.account_name,
        accountType: {
          value: data.account_type ? data.account_type.value : null,
          label: data.account_type ? data.account_type.label : ''
        },
        industry: data.industry,
        phone: data.phone,
        logo: data.logo,
        emailDomain: data.email_domain,
        website: data.website,
        relatedData: data.relatedData,
        companyName: data.commercial_title,
        taxNumber: data.tax_code,
        taxOffice: data.tax_area,
        billingCountry: data.billing_country,
        state: data.state,
        billingCity: data.billing_city,
        billingTown: data.billing_town,
        billingState: data.billing_state,
        billingAddress: data.billing_address,
        billingZipcode: data.billing_zipcode,
        billingLocation: data.billing_location,
        sla: data.sla ? data.sla.value : null,
        slaLevel: data.sla_level ? data.sla_level.value : null,
        slaLabel: data.sla ? data.sla.label : '',
        slaLevelLabel: data.sla_level ? data.sla_level.label : '',
        supportOwner: data.support_owner ? _objectSpread(_objectSpread({}, data.support_owner), {}, {
          userId: data.support_owner.value
        }) : {
          value: null,
          label: ''
        },
        supportFollowers: data.support_followers ? data.support_followers.map(function (k) {
          return k.id.substring(1) * 1;
        }) : [],
        openTasks: data.open_tasks,
        activeProjects: data.active_projects,
        activeDeals: data.active_deals,
        recordId: data.record_id,
        record_id: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {
        account_name: data.accountName,
        account_type: data.accountType && data.accountType.value,
        account_status: data.accountStatus && data.accountStatus.value,
        industry: data.industry ? data.industry.value : null,
        phone: data.phone,
        email_domain: data.emailDomain,
        website: data.website,
        commercial_title: data.companyName,
        tax_code: data.taxNumber,
        tax_area: data.taxOffice,
        billing_country: data.billingCountry ? data.billingCountry.value : null,
        state: data.state,
        billing_city: data.billingCity,
        billing_town: data.billingTown,
        billing_state: data.billingState,
        billing_address: data.billingAddress,
        billing_zipcode: data.billingZipcode,
        billing_location: data.billingLocation,
        sla: data.sla,
        sla_level: data.slaLevel,
        support_owner: data.supportOwner && data.supportOwner.value ? data.supportOwner.value : data.supportOwner,
        support_followers: data.supportFollowers && data.supportFollowers[0] ? data.supportFollowers.map(function (k) {
          return 'U' + k.value;
        }).join(",") : null,
        record_id: data.recordId ? data.recordId : data.record_id ? data.record_id : null
      };
    }
  }]);
  return CrmAccountTransformer;
}(BaseTransformer);